import React, { Component } from 'react';
import {Link,Redirect} from 'react-router-dom';
import {Form,Select,Input,Radio,InputNumber ,Button ,Breadcrumb,Spin,message,Checkbox} from 'antd';
import UploadFile from '../form/uploadFile';
import UploadFiles from '../form/uploadFiles';
import DatePicker from '../form/datePicker';
import Transfer from '../form/transfer';
import Combobox from '../form/combobox';
import moment from 'moment';
import servers from '@/api/server';
import history from '@/containers/history';
import {signLab,initialPage,modeList} from '@/api/api';
import util from '@/api/util';
import styles from './login.module.css';

const FormItem  = Form.Item;
const CheckboxGroup = Checkbox.Group;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const { TextArea } = Input;

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 12 },
};
const formTailLayout = {
    wrapperCol: { span: 12, offset: 6 },
};

class SignLab extends Component{
    constructor(props){
        super(props);
        if(props.location.state){
            this.id = props.location.state.id;
        };
        let httpStr = window.location.host.startsWith('http') ? '' : 'http://';
        this.state = {
            submit_loading:false,
            desUrlList:[],
            opUrlList:[],
            picUrlList:[],
            memberMockData:[],
            memberTargetKeys_0:[],
            memberTargetKeys_1:[],
            eqtNames:[],
            brandId:'',
            infoData:{},
            eqtList:[],
            buyTimeString:'',
            logoPath:httpStr + window.location.host + '/labpro/resources/skin/9/web/logo.png',
            checkedList: [],
            modeList:[],
            indeterminate: true,
            checkedIds:[],
            checkAll: false,
        };
        this.setValue = this.setValue.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.submitLab = this.submitLab.bind(this);
        // this.signSubmit = this.signSubmit.bind(this)
        this.userSubmit = this.userSubmit.bind(this)
        this.getMode = this.getMode.bind(this)
        this.onCheckAllChange = this.onCheckAllChange.bind(this)
    }

    componentDidMount(){
        const that= this;
        this.getMode();       
    }   

    setValue=(feild,value)=>{
        this.setState({
            [feild]:value
        })
    }

    onChange = checkedList => {
        console.log(checkedList);
        this.setState({
          checkedList,
          indeterminate: !!checkedList.length && checkedList.length < this.state.modeList.length,
          checkAll: checkedList.length === this.state.modeList.length
        });
      };
    
      onCheckAllChange = e => {
        this.setState({
          checkedList: e.target.checked ? this.state.checkedIds : [],
          indeterminate: false,
          checkAll: e.target.checked,
        });
      };

    // signSubmit=(e)=>{
    //     const that=this;
    //     e.preventDefault();
    //     this.props.form.validateFields((err, values) => {
    //         if(err) {
    //             console.log(err)
    //             message.warning("表单有未填写的必填项目，请填写后提交！")
    //             return
    //         };
    //         this.userSubmit(values)
    //     });
    // }

     // 注册请求
     userSubmit(values){
        const that = this;
        that.setState({
            sureLoading:true
        });
        var modes='';
        if(that.state.checkAll){
            modes='0';
        }
        else{
            modes=that.state.checkedList.join(',')
        }
        let params = Object.assign({},values,{
            source:1,
            modes:modes
        })

        console.log(params)
        signLab(params,res=>{
            console.log(res);
            that.setValue('submit_loading',false)
            if(res.statusCode === 1000){
                var con = "您已申请成功，我们将尽快为您开通。如需加急，请电话联系"+res.phone+"，谢谢！";
                message.success(con);
                that.props.history.push( '/login',null)
            }else{
                message.warning(res.message)
            }
        },err=>{
            console.log(err + '');
            message.error('提交失败')
            that.setValue('submit_loading',false)
        })
    }

    // 获取注册模块
    getMode(){
        const that = this;
        
        modeList({},res=>{
            console.log(res);
            // console.log(err);
            that.setState({
                sureLoading:false
            });
            if(res.statusCode === 1000){
                var checkedIds = [];
                for(var i=0;i<res.modeList.length;i++){
                    checkedIds.push(res.modeList[i].id)
                }
                that.setState({
                    checkedIds,
                    modeList:res.modeList                
                });
            }else{
                message.warning(res.message)
            }
        },err=>{
            that.setState({
                sureLoading:false
            });
            console.log(err)
            message.error('获取失败')
        })
    }

    // 表单校验，参数校验
    handleSubmit(e){
        e.preventDefault();
        const that = this;
        this.props.form.validateFields((err, values) => {
            console.log(values);
            if(err) {
              console.log(err);
              return
            };
            that.setValue('submit_loading',true);
            let params = {};
            for(let i in values){
                if(typeof values[i] != 'undefined'){
                    switch (i) {
                        case 'timeNum':
                            params[i] = parseInt(values[i]);
                            break;
                        default:
                            params[i] = values[i];
                    }
                };
            };
            if(!params.peopleNum){
                params.peopleNum=1;
            }
            params.source=1;
            console.log(params)
            that.userSubmit(params);
          });
    }

    // 表单提交
    submitLab(params){
        console.log(params)
        const that= this;
        signLab(params,res=>{
            console.log(res);
            that.setValue('submit_loading',false)
            if(res.statusCode === 1000){
                var con = "您已申请成功，我们将尽快为您开通。如需加急，请电话联系"+res.phone+"，谢谢！";
                message.success(con);
                that.props.history.push( '/login',null)
            }
        },err=>{
            console.log(err + '');
            message.error('提交失败')
            that.setValue('submit_loading',false)
        })
    }

    render(){
        const {submit_loading,logoPath} = this.state;
        const {getFieldDecorator,getFieldValue} = this.props.form;
        return(
            <div className={styles.login} id="login">
                <h1>
                    <img src={logoPath} alt="logo"/>
                </h1>
                <p className={styles.surport}>Copyright © 2018-2019 湖南巨擘科技有限公司 版权所有<br/>客服QQ:2471427571&nbsp;&nbsp;&nbsp;客服电话：18670037735&nbsp;&nbsp;&nbsp;7*24小时为您服务</p>
                
                <Form className={styles.login_form} onSubmit={this.handleSubmit}>
                <div className={styles.login_overflow}>

                    <FormItem {...formTailLayout} >
                        
                    </FormItem>
                    <FormItem {...formItemLayout} label="实验室名称">
                        {getFieldDecorator('labName', {
                            rules: [{required: true,message:'请输入'}],
                            validateTrigger:"onBlur"
                        })(
                            <Input 
                                autoComplete="off" 
                                disableautocomplete='true'
                                size='large'
                                placeholder="请输入实验室名称"
                                style={{width:"320px"}}
                            />
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="联系人姓名">
                        {getFieldDecorator('linkName', {
                            rules: [{required: true,message:'请输入'}],
                            validateTrigger:"onBlur"
                        })(
                            <Input 
                                autoComplete="off" 
                                disableautocomplete='true'
                                size='large'
                                placeholder="请输入联系人姓名"
                                style={{width:"320px"}}
                            />
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="联系人电话">
                        {getFieldDecorator('linkPhone', {
                            rules: [{required: true,message:'请输入'}],
                            validateTrigger:"onBlur"
                        })(
                            <Input 
                                autoComplete="off" 
                                disableautocomplete='true'
                                size='large'
                                placeholder="请输入联系人电话"
                                style={{width:"320px"}}
                            />
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="QQ">
                        {getFieldDecorator('linkQQ',{
                            rules: [
                                {required: true,message: '请输入联系QQ'}
                            ],
                            validateTrigger:'onBlur',
                        })(
                            <Input 
                                placeholder="请输入联系QQ"
                                size='large'
                                autoComplete="off" disableautocomplete='true'
                            />
                        )}
                    </FormItem>
                    
                    <FormItem {...formItemLayout} label="邮箱">
                        {getFieldDecorator('linkEmail',{
                            validateTrigger:'onBlur',
                        })(
                            <Input 
                                placeholder="请输入联系邮箱"
                                size='large'
                                autoComplete="off" disableautocomplete='true'
                            />
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="所属机构">
                        {getFieldDecorator('orgName', {
                            validateTrigger:"onBlur"
                        })(
                            <Input 
                                autoComplete="off" 
                                disableautocomplete='true'
                                size='large'
                                placeholder="请输入所属机构"
                                style={{width:"320px"}}
                            />
                        )}
                    </FormItem>
                    
                    <FormItem {...formItemLayout} label="实验室详细地址">
                        {getFieldDecorator('labAddress', {
                            validateTrigger:"onBlur"
                        })(
                            <Input 
                                autoComplete="off" 
                                disableautocomplete='true'
                                size='large'
                                placeholder="请输入实验室详细地址"
                                style={{width:"320px"}}
                            />
                        )}
                    </FormItem>
                    
                    <FormItem {...formItemLayout} label="账号数">
                        {getFieldDecorator('peopleNum',{
                            rules: [
                                {patern:/^\d+$/,message: '请输入实验开通账号数!'}
                            ],
                            validateTrigger:'onBlur',
                        })(
                            <InputNumber 
                            placeholder="请输入开通账号数"
                                size='large' min={0}
                                autoComplete="off" disableautocomplete='true'
                            />
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="登录名">
                    {getFieldDecorator('userName',{
                        validateTrigger:'onBlur',
                    })(
                        <Input 
                            placeholder="请输入管理用户登录名"
                            size='large'
                            autoComplete="off" disableautocomplete='true'
                        />
                    )}
                </FormItem>
                <FormItem {...formItemLayout} label="密码">
                    {getFieldDecorator('pwd',{                        
                        validateTrigger:'onBlur',
                    })(
                        <Input 
                            placeholder="请输入管理用户登录密码"
                            size='large'
                            autoComplete="off" disableautocomplete='true'
                        />
                    )}
                </FormItem>
                
                <FormItem {...formItemLayout} label="功能模块">
                    {getFieldDecorator('modes',{                        
                        validateTrigger:'onBlur',
                    })(
                        <div>
                            <div style={{ borderBottom: '1px solid #E9E9E9' }}>
                            <Checkbox
                                onChange={this.onCheckAllChange}
                                checked={this.state.checkAll}
                            >
                                所有功能
                            </Checkbox>
                            </div>
                            <CheckboxGroup
                            options={this.state.modeList}
                            value={this.state.checkedList}
                            onChange={this.onChange}
                            />
                        </div>
                    )}
                </FormItem>
                </div>
                <div>
                    <FormItem {...formTailLayout}>
                        <div className={styles.login_btns}>
                            <Button htmlType="submit" type="primary" className={styles.signLab_btn} size="large"loading={submit_loading}>实验室注册</Button>  
                            <span className={styles.login_sign}> &nbsp;&nbsp;&nbsp;&nbsp;有账号？<a href="/login" >去登录</a></span>
                        </div>
                    </FormItem>
                    </div>
                </Form>
            </div>
        )
    }
}

export default Form.create({})(SignLab);